import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoggingService } from '@logging/logging.service';
import { AuthState } from '../state/models/auth.models';
import { environment } from '@env/environment';
import { AbstractEntityDataProvider } from '@entity-framework/entity-record/entity-data-provider/abstract-entity.data-provider';

@Injectable({ providedIn: 'root' })
export class TokenRefreshDataProvider extends AbstractEntityDataProvider<AuthState> {
  constructor(
    protected override httpClient: HttpClient,
    protected override logger: LoggingService
  ) {
    super(httpClient, logger);
  }

  protected override apiRoot = `${environment.apiPaths.authorisation}refreshtoken`;

  refreshActiveAuthState$(refreshToken: string): Observable<AuthState> {
    const params = new HttpParams().set('refreshToken', refreshToken);

    this.logger.trace('TokenRefreshDataProvider: token refreshing', refreshToken);

    return this.httpClient.post<AuthState>(this.apiRoot, {}, { params }).pipe(
      map((response) => ({
        ...response,
        id: response.userId
      }))
    );
  }
}
